const urlParams = new URLSearchParams(window.location.search)
const isLab = urlParams.get('lab')

if (isLab) {
	$labSect = document.querySelector('.comp-lab')
	$labSect.classList.remove('d-none')
}